import PropTypes from 'prop-types'
import React from 'react'
import NextLink from 'next/link'

const SidebarOptions = ({ options, title, className }) => (
  <div
    className={`flex flex-col pb-10 text-left ${className}`}
    data-testid="options"
  >
    <h2
      className="border-gray-165 mb-1 border-b pb-2 text-xl text-blue-700"
      data-testid="h2"
    >
      {title}
    </h2>
    <ul className="list-disc" data-testid="options-list">
      {options.map((item, index) => (
        <li
          key={`option_li_${index}`}
          className="flex items-center py-1 text-sm font-normal"
          data-testid="list-item"
        >
          <NextLink
            href={item.url}
            data-testid="link"
            className="hover:text-blue-700"
          >
            {item.title}
          </NextLink>
        </li>
      ))}
    </ul>
  </div>
)

SidebarOptions.defaultProps = {
  options: [],
  title: '',
  className: '',
  stateSlug: '',
}

SidebarOptions.propTypes = {
  options: PropTypes.array,
  title: PropTypes.string,
  className: PropTypes.string,
  stateSlug: PropTypes.string,
}

export default SidebarOptions
